/* -----------------------------
    CART COUNTER
   ----------------------------- */

document.addEventListener("theme:cart:change", (event) => {
  const cart = event?.detail?.cart;

  if (!cart?.item_count) {
    return;
  }

  const cartCounterElements = [...document.querySelectorAll("[data-cart-count]")];

  cartCounterElements.forEach((cartCount) => {
    cartCount.setAttribute("data-cart-count", cart.item_count);
  });
});

/* ----------------------------- */
